import { useTranslation } from 'react-i18next'
import { Icon } from '../Icon/Icon'
import type { IconName } from '../Icon/types'
import { cx } from '../utils/cx'
import type { ExplainerBannerProps } from './types'
import './ExplainerBanner.css'

const TONE_ICON: Record<NonNullable<ExplainerBannerProps['tone']>, IconName> = {
  info: 'info',
  warning: 'alert-triangle',
  error: 'x-circle',
  success: 'check-circle',
}

/** Banner explicador (DESIGN.md §4): fondo suave, icono, título y 2-3 frases. Sin botón de cerrar. */
export function ExplainerBanner({ title, children, moreLabel, onMore, moreHref, tone = 'info', icon, className, style }: ExplainerBannerProps) {
  const { t } = useTranslation()
  const label = moreLabel ?? t('v2.comun.masInformacion')
  return (
    <div role="note" className={cx('hp-explainer', `hp-explainer--${tone}`, className)} style={style}>
      <Icon name={icon ?? TONE_ICON[tone]} size={24} className="hp-explainer__icon" />
      <div className="hp-explainer__content">
        {title && <div className="hp-explainer__title">{title}</div>}
        <div className="hp-explainer__text">{children}</div>
        {moreHref ? (
          <a href={moreHref} className="hp-explainer__more" target="_blank" rel="noreferrer">
            {label}
          </a>
        ) : onMore ? (
          <button type="button" onClick={onMore} className="hp-explainer__more">
            {label}
          </button>
        ) : null}
      </div>
    </div>
  )
}
